import React, { Component } from "react";
import { displayBalance } from "../display-balance";
// import { displayChartTransactions } from "../display-chart-transactions";
import { displayMovements } from "../display-movements";
import { translate } from "../../../infrastructure/translate/localization";

export default class MyAccountPage extends Component {
  componentDidMount() {
    displayBalance();
    // displayChartTransactions();
    displayMovements();
  }

  render() {
    return (
      <main className="section">
        <div className="section-header">
          <h1 className="section-title">
            {translate("my-account-section.my-account")}
          </h1>
          <div id="notification-card" />
        </div>
        <div className="section-container with-subsection">
          <div className="container-flex" id="balance-section-container" />
          <div className="container-flex" id="chart-transactions-container" />
          <div className="container-flex" id="table-movements-container" />
        </div>
      </main>
    );
  }
}
